<template>
  <v-container align-center fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md6 lg4 xl4>
        <v-card flat color="grey lighten-5">
          <v-card-text>
            <div class="text-center">
              <p class="font-weight-bold">
                {{ $t("page.nonmemberHome.thanksResgistrationMessage") }}
                <br />{{ $t("page.nonmemberHome.completeContractMessage") }}
              </p>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {};
</script>
